import { render, staticRenderFns } from "./sql-reduction.vue?vue&type=template&id=71fac574&scoped=true&"
import script from "./sql-reduction.vue?vue&type=script&lang=js&"
export * from "./sql-reduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fac574",
  null
  
)

export default component.exports